import React from "react";
import ResponsiveWrapper from "../_responsive-wrapper";
import SelectField from "../select-field";
import BaseInput from "../base-input";

const DropdownProductsSelect = ({ items, onChange, value }) => {
    if (!items) return null;

    const options = items.map((item) => ({
        value: item.id,
        label: item.price > 0 ? `${item.title} - $${item.price}` : item.title,
    }));

    const selectedOption = options.find((option) => option.value === value);

    return (
        <ResponsiveWrapper className="dropdown-products-select">
            <SelectField
                value={selectedOption}
                options={options}
                onChange={(selected) => {
                    const selectedItem = items.find((item) => item.id === selected.value);
                    onChange(selectedItem.id, selectedItem);
                }}
            />
            <div className="configurator-section__personalize-text-preview-label">
                <BaseInput
                    label="*Grommet Size #5 (17mm Inner & 32mm Outer Diameter)"
                />
            </div>
        </ResponsiveWrapper>
    );
};

export default DropdownProductsSelect;
